/**
 * External dependencies.
 */
import { assign, has, isEmpty } from 'lodash';

/**
 * WordPress dependencies
 */
import { applyFilters } from '@wordpress/hooks';

/**
 * Internal dependencies.
 */
import blockInfo from './constants';
const { hookPrefix } = blockInfo;

function styling( props, selector = false ) {
	const { blockAdvanceOptions } = props.attributes;
	const { innerBlock } = blockAdvanceOptions;
	let css = '';
	selector = selector ? selector : `.gutenify-section-${ props.clientId } .gutenify-gallery-carousel-item`;

	let styleNormal = '';
	styleNormal += `${ has( innerBlock, 'textColor' ) && ! isEmpty( innerBlock.textColor ) ? `color: ${ innerBlock.textColor };` : '' }`;
	styleNormal += `${ has( innerBlock, 'backgroundColor' ) && ! isEmpty( innerBlock.backgroundColor ) ? `background: ${ innerBlock.backgroundColor };` : '' }`;
	if ( has( innerBlock, 'backgroundGradient' ) && ! isEmpty( innerBlock.backgroundGradient ) ) {
		styleNormal += `background: ${ innerBlock.backgroundGradient };`;
	}
	styleNormal += `${ has( innerBlock, 'borderColor' ) && ! isEmpty( innerBlock.borderColor ) ? `border-color: ${ innerBlock.borderColor };` : '' }`;
	styleNormal += `${ has( innerBlock, 'borderWidth' ) && innerBlock.borderWidth > 0 ? `border-width: ${ innerBlock.borderWidth }px;` : '' }`;
	styleNormal += `${ has( innerBlock, 'borderWidth' ) && innerBlock.borderWidth > 0 ? `border-style: solid;` : '' }`;
	styleNormal += `${ has( innerBlock, 'borderRadius' ) && ! isEmpty( innerBlock.borderRadius ) ? `border-radius: ${ innerBlock.borderRadius };` : '' }`;
	if ( styleNormal ) {
		css += `${ selector } { ${ styleNormal } }`;
	}

	let styleHover = '';
	styleHover += `${ has( innerBlock, 'hoverTextColor' ) && ! isEmpty( innerBlock.hoverTextColor ) ? `color: ${ innerBlock.hoverTextColor };` : '' }`;
	styleHover += `${ has( innerBlock, 'hoverBackgroundColor' ) && ! isEmpty( innerBlock.hoverBackgroundColor ) ? `background: ${ innerBlock.hoverBackgroundColor };` : '' }`;
	if ( has( innerBlock, 'hoverBackgroundGradient' ) && ! isEmpty( innerBlock.hoverBackgroundGradient ) ) {
		styleHover += `background: ${ innerBlock.hoverBackgroundGradient };`;
	}
	styleHover += `${ has( innerBlock, 'hoverBorderColor' ) && ! isEmpty( innerBlock.hoverBorderColor ) ? `border-color: ${ innerBlock.hoverBorderColor };` : '' }`;

	if ( styleHover ) {
		css += `${ selector }:hover { ${ styleHover } }`;
	}

	return applyFilters( `gutenify--${ hookPrefix }--inline-styles`, css, props );
}

export default styling;

